import React from "react";
import images from "./list";
import "./footer.css";
import logo from "./images/Footer_logo.png";
import { Link } from "react-router-dom";
import document from "./document.pdf";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="footer-section">
      <div className="footer_details">
        <div>
          <img src={logo} alt="" />
          <p>Copyright &copy; Fidel Foundation {year}</p>
          <Link to={document} target="_blank">
            <p>Our Constitution and By-Laws</p>
          </Link>
        </div>
        <div className="links">
          <h1>Useful Links</h1>
          <Link to={"/activities"}>
            <p>Activities</p>
          </Link>
          <Link to={"/contact"}>
            <p>Get In Touch</p>
          </Link>
          <Link to={"/about"}>
            <p>About Us</p>
          </Link>
          <Link to={"/donate"}>
            <p>Donate</p>
          </Link>
        </div>
        <div className="images">
          <h1>Photo Gallery</h1>
          <div className="gallery">
            {images.map((image, index) => (
              <div key={index} className="size_gallery">
                <img src={image} alt="" />
              </div>
            ))}
          </div>
          <Link to={"/gallery"}>
            <p>View all photos</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Footer;
